module.exports = __webpack_public_path__ + "static/media/lambda.a3f6a2dd.svg";